<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  import { ConfigProvider } from 'ant-design-vue';
  dayjs.locale('zh-cn');
  export default {
    name: 'App',
    data() {
      return {
        locale: zhCN,
      };
    },
    mounted(){
      ConfigProvider.config({
        theme: {
          primaryColor: '#3562FD',
        },
      });
    },
  }
</script>

<style>
</style>
